const FitAssistantStatusIconEnum = Object.freeze({
  NoSelection: 'le-icon-plus-circle',
  Confirmed: 'le-icon-check-circle',
  Unconfirmed: 'le-icon-alert-circle',
  NoFit: 'le-icon-x-circle',
  RackMounting: 'le-icon-check-circle',
});

export default FitAssistantStatusIconEnum;
